// import React, { useEffect, useState } from "react";
// import PhoneInput from "react-phone-input-2";
// import "react-phone-input-2/lib/bootstrap.css";
// import { Box } from "@mui/material";

// const CustomPhoneNumberInput = ({
//   value,
//   onChange,
//   setFieldValue,
//   countryCode,
// }) => {
//   const [phone, setPhone] = useState(value || "");

//   useEffect(() => {
//     setPhone(value);
//   }, [value]);

//   const handlePhoneChange = (phone, country) => {
//     setPhone(phone);
//     if (onChange) onChange(phone, country);
//   };

//   return (
//     <Box sx={{ width: "100%" }}>
//       <PhoneInput
//         country={countryCode || "eg"} // Use the provided country code or default to 'eg'
//         enableSearch={true}
//         value={phone}
//         onChange={handlePhoneChange}
//         inputStyle={{
//           width: "100%",
//           fontSize: "16px",
//           borderRadius: "4px",
//           border: "1px solid #ccc",
//           // backgroundColor: "lightblue",
//           padding: " 20px",
//           boxSizing: "border-box", 
//         }}
//         buttonStyle={{
//           border: "1px solid #ccc",
//           borderRadius: "4px 0 0 4px",
//           height: "100%",
//           width: "40px",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           background: "lightblue",
//         }}
//         dropdownStyle={{
//           border: "1px solid #ccc",
//           borderRadius: "4px",
//         }}
//       />
//     </Box>
//   );
// };

// export default CustomPhoneNumberInput;

import React, { useEffect, useState } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import { Box } from "@mui/material";

const CustomPhoneNumberInput = ({
  value,
  onChange,
  setFieldValue,
  countryCode,
}) => {
  const [phone, setPhone] = useState(value || "");

  useEffect(() => {
    setPhone(value);
  }, [value]);

  const handlePhoneChange = (phone, country) => {
    setPhone(phone);
    if (onChange) onChange(phone, country);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <PhoneInput
        country={countryCode || "eg"} 
        enableSearch={true}
        value={phone}
        onChange={handlePhoneChange}
        inputStyle={{
          width: "100%",                   
          fontSize: "14px",                  
          borderRadius: "4px",              
          border: "1px solid #ccc",        
          height: "20px",                  
          boxSizing: "border-box",           
        }}
        buttonStyle={{
          borderRadius: "4px 0 0 4px",  
          // border: "1px solid #ccc",    
          height: "36px",                 
          width: "60px",                  
          display: "flex",              
          alignItems: "start",           
          justifyContent: "start",         
          // background: "lightblue",      
          fontSize: "14px",               
        }}
        dropdownStyle={{
          border: "1px solid #ccc",          
          borderRadius: "4px",             
          fontSize: "14px",                 
        }}
      />
    </Box>
  );
};

export default CustomPhoneNumberInput;

